import React from "react";
import { motion } from "framer-motion";
import { useLanguage } from "@/context/LanguageContext";

const PHOTOS = [
  {
    src: "https://customer-assets.emergentagent.com/job_facility-experts-12/artifacts/rodgb98e_zemka%201.webp",
    captionDe: "Unser Service-Fahrzeug",
    captionEn: "Our service vehicle",
    span: "md:col-span-2 md:row-span-2",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_facility-experts-12/artifacts/szy5ier1_zemka%205.webp",
    captionDe: "Fenster- & Glasreinigung",
    captionEn: "Window & glass cleaning",
    span: "",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_facility-experts-12/artifacts/u7xc9x96_zemka%204.webp",
    captionDe: "Tiefenreinigung mit Maschine",
    captionEn: "Deep clean with machinery",
    span: "",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_facility-experts-12/artifacts/3duxl59z_zemka%203.webp",
    captionDe: "Sorgfältige Detailarbeit",
    captionEn: "Meticulous detail work",
    span: "",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_facility-experts-12/artifacts/a0e4sdha_zemka%202.webp",
    captionDe: "Vor Ort in Penzberg",
    captionEn: "On site in Penzberg",
    span: "",
  },
];

export const Gallery = () => {
  const { lang } = useLanguage();
  const eyebrow = lang === "de" ? "Echte Einsätze" : "Real jobs";
  const title = lang === "de" ? "Eindrücke aus unserer täglichen Arbeit" : "Impressions from our daily work";
  const subtitle =
    lang === "de"
      ? "Keine Stockfotos – das ist ZEMKA bei der Arbeit in Penzberg und Umgebung."
      : "No stock photos – this is ZEMKA at work in Penzberg and the surrounding region.";

  return (
    <section id="gallery" data-testid="gallery-section" className="bg-white py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
          className="max-w-3xl"
        >
          <span className="text-xs font-semibold tracking-[0.2em] uppercase text-cyan-600">{eyebrow}</span>
          <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 leading-tight">
            {title}
          </h2>
          <p className="mt-5 text-base sm:text-lg text-slate-600 leading-relaxed">{subtitle}</p>
        </motion.div>

        <div className="mt-14 grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4 auto-rows-[180px] md:auto-rows-[220px]">
          {PHOTOS.map((p, i) => (
            <motion.figure
              key={i}
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] }}
              className={`relative overflow-hidden bg-slate-200 group ${p.span}`}
              data-testid={`gallery-item-${i}`}
            >
              <img
                src={p.src}
                alt={lang === "de" ? p.captionDe : p.captionEn}
                loading="lazy"
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0F172A]/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              <figcaption className="absolute bottom-3 left-3 right-3 text-white text-xs sm:text-sm font-semibold opacity-0 group-hover:opacity-100 transition-opacity duration-300 translate-y-2 group-hover:translate-y-0">
                {lang === "de" ? p.captionDe : p.captionEn}
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
};
